import React from 'react';
import { Redirect } from 'expo-router';
import { ROUTES } from '@/shared/constants/routes';

// The admin dashboard is web-only (see admin.web.tsx)
export default function AdminScreen() {
  return <Redirect href={ROUTES.SESSIONS.path} />;
}
